import React from 'react'
import { Api } from '../../../useFetch'
import { useFormInput } from '../../Forms/Input/InputHook'
import Input from '../../Forms/Input/Input'
import Errors from '../../Forms/Errors/Errors'
import Preloader from '../../Utilities/Preloader'
import axios from 'axios'


const NewsletterForm = props => {

  const [data, setData] = Api({
    method: 'post',
    url: '/api/newsletter'
  })

  const [email, unsetEmail] = useFormInput({
    type: 'text',
    name: 'email',
    id: 'email',
    placeholder: 'Adres email',
    value: '',
    validation: ['required', 'email'],
    validationErrors: [],
    valid: true
  })

  const [regulations, _] = useFormInput({
    type: 'checkbox',
    name: 'regulations',
    id: 'regulations',
    value: false,
    className: 'custom-checkbox newsletter-regulations',
    label: 'Wyrażam zgodę na przetwarzanie przez ViaCamp sp. z o.o. moich danych osobowych w postaci adresu mailowego w celu przesyłania mi informacji marketingowych dotyczących produktów i usług oferowanych przez ViaCamp sp. z o.o. za pomocą wiadomości mailowych.',
    validation: ['checked'],
    validationErrors: []
  })

  const saveHandler = (e) => {
    e.preventDefault()
    grecaptcha.ready(function () {
      grecaptcha.execute('6LdTadgZAAAAAI4lkks7Mqo1HgWKVl6xgJMNSryP', {action: 'submit'}).then(function (token) {
        axios.get('/sanctum/csrf-cookie').then(response => {
          setData({
            email: email.value,
            regulations: regulations.value,
            recaptcha: token
          })
        })
      })
    })
    unsetEmail()
  }

  return (
    <form className="newsletter__form" method="POST">
      <div className="row">
        <div className="col-12 col-md-8">
          <Input {...email} />
        </div>
        <div className="col-12 col-md-4">
          <div className="form-group">
            <button disabled={!email.validation.isValid || data.data} className="btn btn-green" onClick={saveHandler}>Wyślij</button>
          </div>
        </div>
        <div className="col-12">
          <Input {...regulations} />
          <div className="form-group">
            {data.loading
              ? <Preloader />
              : <span style={{color: '#fff'}}>{data.data}</span>}
            <Errors errors={data.error} />
          </div>
        </div>
      </div>
    </form>
  )

}

export default NewsletterForm
